<template>
  <v-container>
    <v-row justify="center">
      <ViewHeader :title="viewTitle" />
      <v-col cols="12">
        <v-card class="pa-4">
          <v-tabs
            v-model="active"
            slider-color="warning"
            color="dark"
            centered
            class="mb-5"
          >
            <v-tab v-for="tab in tabs" :key="tab.id">
              {{ $t(tab.label) }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="active">
            <v-tab-item>
              <BusinessAddressesHOC v-if="active === 0" />
            </v-tab-item>
            <v-tab-item>
              <WebsitesHOC v-if="active === 1" />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import serviceHandler from "@/helpers/handlers/service";
import businessAddressesService from "@/services/businessAddresses";
import { gtmEngagement as gtmEngagementMixin } from "@/helpers/mixins/gtm-engagement";

import ViewHeader from "@/components/ui/ViewHeader.vue";
import BusinessAddressesHOC from "@/components/hoc/Competition/BusinessAddresses.vue";
import WebsitesHOC from "@/components/hoc/Competition/Websites.vue";

import cuid from "cuid";

export default {
  name: "CompetitionVisibility",
  components: {
    BusinessAddressesHOC,
    WebsitesHOC,
    ViewHeader
  },
  mixins: [gtmEngagementMixin],
  data() {
    return {
      active: 0,
      viewTitle: this.$t("message.common.competitionVisibility"),
      businessAddresses: [],
      tabs: [{ id: cuid(), label: "message.common.businessAddresses" }]
    };
  },

  methods: {
    async fetchBusinessAddresses() {
      const data = await serviceHandler(
        businessAddressesService.getBusinessAddressesData()
      );

      if (data.length > 0) {
        this.businessAddresses = data;
      }
    }
  },

  async created() {
    await this.fetchBusinessAddresses();

    if (!this.businessAddresses.length > 0) {
      this.active = 1;
    }
  },

  mounted() {
    this.mixin__setGtmEngagementTimeouts();
  }
};
</script>

<style lang="scss" scoped>
.summary__header {
  color: $grey-darker;
  font-weight: 600;
}
</style>
